import Header from './Header/Header'
import Footer from './Footer/Footer'
import Secure from './Secure/Secure'
import ScrollToTop from './ScrollToTop/ScrollToTop'
import { AuthLevelRequired } from '../../../types/Auth'

type Props = {
  children: React.ReactNode
  className?: string
  authLevelRequired?: AuthLevelRequired
  hideNavigation?: boolean
  noFooter?: boolean
  disableDynamicHeightHeader?: boolean
  smallHeader?: boolean
}

const Layout: React.FC<Props> = ({
  children,
  className,
  hideNavigation,
  authLevelRequired = [],
  noFooter = false,
  disableDynamicHeightHeader = false,
  smallHeader = false,
}) => {
  return (
    <div className={`bg-background ${className}`}>
      <Secure authLevelRequired={authLevelRequired}>
        <ScrollToTop />
        <Header hideNavigation={hideNavigation} disableDynamicHeight={disableDynamicHeightHeader} small={smallHeader} />
        <div className={`relative overflow-x-hidden min-h-screen`}>{children}</div>
        {!noFooter && <Footer />}
      </Secure>
    </div>
  )
}

export default Layout
